/**
 * A simple data model abstraction
 */

import uid from 'uid'

function Record (fields, options={}) {
  // What field should identify the record?
  // This will be returned from `toString()`
  const identifier = options.idAttribute || 'id'

  function Schema(...params) {
    Object.assign(this, fields, { [identifier]: uid() }, ...params)
  }

  Schema.prototype = {
    constructor: Schema,

    toString() {
      return `${ this[identifier] }`
    }
  }

  return Schema
}

export default Record



/** WEBPACK FOOTER **
 ** ./web/static/lib/record.js
 **/